
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[partnership]",
      function () {
        return require("private-next-pages/[partnership]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[partnership]"])
      });
    }
  